(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("@ecomplus/utils"), require("@ecomplus/storefront-twbs"));
	else if(typeof define === 'function' && define.amd)
		define([, , ], factory);
	else if(typeof exports === 'object')
		exports["widgetMartan"] = factory(require("vue"), require("@ecomplus/utils"), require("@ecomplus/storefront-twbs"));
	else
		root["widgetMartan"] = factory(root["Vue"], root["ecomUtils"], root["__storefrontTwbs"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__26__, __WEBPACK_EXTERNAL_MODULE__27__) {
return 